import React, { useEffect } from 'react'
import CrossIcon from '../Images/CrossIcon'
import {
  AlertSnackBarCloseBtn,
  AlertSnackBarContainer,
  AlertSnackBarText,
} from './styles'

let setTimeOutInstance = null
const AlertSnackBar = (props) => {
  useEffect(() => {
    setTimeOutInstance = setTimeout(() => {
      props.close()
    }, 3000)
    return () => clearTimeout(setTimeOutInstance)
  })
  return (
    <AlertSnackBarContainer
      bottomMobile={props.bottomMobile ?? '8px'}
      style={props.container_styles}
      mobileWidth={props.mobileWidth}
    >
      <AlertSnackBarText style={props.text_styles}>
        {props.text}
      </AlertSnackBarText>
      {props.closeBtn && (
        <AlertSnackBarCloseBtn onClick={props.close}>
          <CrossIcon width="12" height="12" />
        </AlertSnackBarCloseBtn>
      )}
    </AlertSnackBarContainer>
  )
}

export default AlertSnackBar
